import InputTextOnly from "../../controls/InputTextOnly";

export default function CustomerAddressesForm(props) {
  const { billing_address, shipping_address } = props;

  return (
    <div className="p-4">
      <div className="space-y-3">
        <div>
          <p className="text-lg font-semibold">Billing Address</p>
          <div className="mt-3 grid grid-cols-1 gap-4 max-w-4xl">
            <div>
              <InputTextOnly
                label="Billing Address Line 1"
                name="line1"
                value={billing_address.line1}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Billing Address Line 2"
                name="line2"
                value={billing_address.line2}
                labelOn={true}
                disabled={true}
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-4 gap-4 max-w-4xl">
            <div>
              <InputTextOnly
                label="City"
                name="city"
                value={billing_address.city}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Province"
                name="province"
                value={billing_address.province}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="State"
                name="state"
                value={billing_address.state}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Country"
                name="country_code"
                value={billing_address.country_code}
                labelOn={true}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="pt-10">
          <p className="text-lg font-semibold">Shipping Address</p>
          <div className="mt-3 grid grid-cols-1 gap-4 max-w-4xl">
            <div>
              <InputTextOnly
                label="Billing Address Line 1"
                name="line1"
                value={shipping_address.line1}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Billing Address Line 2"
                name="line2"
                value={shipping_address.line2}
                labelOn={true}
                disabled={true}
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-4 gap-4 max-w-4xl">
            <div>
              <InputTextOnly
                label="City"
                name="city"
                value={shipping_address.city}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Province"
                name="province"
                value={shipping_address.province}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="State"
                name="state"
                value={shipping_address.state}
                labelOn={true}
                disabled={true}
              />
            </div>
            <div>
              <InputTextOnly
                label="Country"
                name="country_code"
                value={shipping_address.country_code}
                labelOn={true}
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
